import { media } from "@features/adaptive/breakpoints";
import { colors } from "@packages/uiKit";
import Image from "next/image";
import styled, { css } from "styled-components";

export const StyledSidebarImage = styled(Image)<{
  $isCurrent: boolean;
}>`
  width: 56px;
  height: 70px;
  object-fit: cover;
  border-radius: 12px;
  transition: 0.3s ease;
  border: 1px solid transparent;
  cursor: pointer;

  ${media.down("desktop")} {
    width: 40px;
    height: 40px;
  }

  ${({ $isCurrent }) =>
    $isCurrent &&
    css`
      border: 1px solid ${colors.dark};
    `}

  :hover {
    border: 1px solid ${colors.dark};
  }
`;
